import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action";
import { Qualifier } from "../../internal/qualifier/Qualifier";
import { toFloatAsString } from "../../internal/utils/toFloatAsString";
/**
 * @extends SDK.Action
 * @memberOf Actions.Transcode
 * @description Controls the keyframe interval of the delivered video.
 * @see Visit {@link Actions.Transcode|Transcode} for an example
 */

var KeyframeIntervalsAction = /*#__PURE__*/function (_Action) {
  _inherits(KeyframeIntervalsAction, _Action);

  var _super = _createSuper(KeyframeIntervalsAction);

  function KeyframeIntervalsAction(interval) {
    var _this;

    _classCallCheck(this, KeyframeIntervalsAction);

    _this = _super.call(this);

    _this.addQualifier(new Qualifier('ki', toFloatAsString(interval)));

    return _this;
  }

  return KeyframeIntervalsAction;
}(Action);

export default KeyframeIntervalsAction;